// extracted by mini-css-extract-plugin
export default {"sideMenuBtn":"SideMenuBtn_sideMenuBtn__UknlF","divIcon":"SideMenuBtn_divIcon__Mx1PD","spinner":"SideMenuBtn_spinner__sr7LF","spin":"SideMenuBtn_spin__k7P+d"};